import React from "react"

import { QidDatapoint } from "server/models"
import { Table } from "client/components"
import { QidResultType } from "client/store"

import Columns from "./columns"
import { DatapointWrapper } from "../styled"

interface DatapointProps {
    datapoint: QidDatapoint
    datapointAvg: QidResultType
}

const Datapoint = ({
    datapoint,
    datapointAvg,
}: DatapointProps) => {
    const ids: number[] = [0, datapoint.id]
    const list: { [id: number]: QidDatapoint | QidResultType } = {
        0: datapointAvg,
        [datapoint.id]: datapoint,
    }
    datapoint.datapoints.forEach((nested) => {
        ids.push(nested.id)
        list[nested.id] = nested
    })

    const columns = Columns()
    return (
        <DatapointWrapper>
            <Table
                columns={columns}
                dataList={list}
                dataIds={ids}
                rowSize="sm"
                showPagination={false}
                showBottom={false}
            />
        </DatapointWrapper>
    )
}
export default Datapoint
